const importTool = {

    // headings
    download: 'Download CSV Sample File',
    downloadApplication: 'Download Application ZIP Sample File',
    requirement: 'Data Requirements',
    requirement1: 'Mandatory fields: Student Number, SISEnabled, Grade Notifications',
    requirement2: 'Date format: {format}',

    csvHeader: 'CSV contains header',
    csvHeaderText: 'The first row in the CSV file will be ignored.',

    csvDelimiter: 'Semicolon delimiter',
    csvDelimiterText: 'Use semicolon as a field separator.',

    csvQualifier: 'CSV contains text qualifier (double quotes around text)',
    csvQualifierText: 'Detect and remove text qualifier.',

    updateGrades: 'Update existing grades',
    updateGradesText: 'Warning: student(s) will receive a new grade notification if an existing grade changes.',
    disableGradeNotification: 'Disable Grade Notifications',

    signaturePad: 'Signature Pad',

    record: 'Import Record',
    id: 'ID',
    partner: 'Partner Code',
    user: 'User',
    type: 'Type',
    data: 'Data',
    signature: 'Signature',
    date: 'Date',
    student: 'Student',
    grade: 'Grade',
    graduation: 'Graduation',
};

export default importTool;